/**
 * Takes a source aray and returns a unique array of randomly
 * picked items from the source array. The length of the
 * returned array is determined by the count parameter.
 * @param {Array} sourceArray The source array to pick from.
 * @param {Number} count The number of items to pick. Must be lower than the array length
 *
 * @returns {Array} The resulting array
 */
export const getRandomItemsFromArray = (sourceArray = [], count = 1) => {
	let result = new Array(count),
		len = sourceArray.length,
		taken = new Array(len);

	if (count > len) {
		throw new RangeError(
			"getRandomItemsFromArray: more elements taken than available"
		);
	}

	while (count--) {
		let x = Math.floor(Math.random() * len);
		result[count] = sourceArray[x in taken ? taken[x] : x];
		taken[x] = --len in taken ? taken[len] : len;
	}

	return result;
};

/**
 * Fires a pageview event call to Permutive.
 * @param {Object} data The data object to attach to the event call.
 */
export const firePermutiveEvent = (data = {}) => {
	if (
		typeof window.__PRERENDER_INJECTED === "undefined" &&
		typeof window.__TEST__ === "undefined"
	) {
		// 2. Fire Permutive call.
		const a = window?.permutive?.addon;
		if (typeof a === "function") {
			a("web", data);
		}
	}
};
